import { SIZE_TINY } from '../../common/Modal';
import { Button } from '../../common/Button/Button';
import { Icon } from 'semantic-ui-react';
import React, { useState } from 'react';
import AdvancedModal from '../../common/Modal/AdvancedModal';

const NEW_APP_URL = 'https://app.dollero.app';
const SUPPORT_EMAIL = 'hello@dollero.app';

const DeprecationNoticeModal = () => {
	const [modalOpen, setModalOpen] = useState(true);
	const onClose = () => setModalOpen(false);

	return <AdvancedModal
		title={'This version of Dollero is being deprecated'}
		open={modalOpen}
		size={SIZE_TINY}
		onClose={onClose}
		actions={
			<>
				<Button onClick={onClose}>
					<Icon name="remove" /> Close
				</Button>
				<Button
					type={'success'}
					onClick={() => window.open(NEW_APP_URL, '_blank', 'noopener,noreferrer')}
				>
					<Icon name="external" /> Go to new version
				</Button>
			</>
		}
	>
		<p>
			A new version of Dollero is now available
			at <a href={NEW_APP_URL} target="_blank" rel="noopener noreferrer">app.dollero.app</a>.
		</p>
		<p>
			If you have any questions, please email us
			at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
		</p>
	</AdvancedModal>
}

export default DeprecationNoticeModal;
